import React from "react";
import ContactusForm from "../contactus/form";

export const ComingSoonForm = () => {
  return (
    <>
      <div style={{ color: "transparent", lineHeight: "0" }} id={"form"}>
        a
      </div>
      <ContactusForm style={{ marginTop: "80px" }} />
    </>
  );
};

export default ComingSoonForm;
